import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 16 27",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 27\" id=\"icon-arrow--left\"><path d=\"M14.5 1L2 13.5 14.5 26\" stroke=\"#000\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol